<template>
  <div
          class="badge"
          :class="classes">
    <div class="inline-block fill-current stroke-current">
      <slot name="icon"/>
    </div>
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'UiBadge',
    props: {
      type: {
        type: String,
        default: 'primary'
      },
      size: {
        type: String,
        default: 'm'
      }
    },
    computed: {
      classes () {
        let classes = []
        classes.push(`badge-${this.type}`)
        classes.push(`badge-size-${this.size}`)

        return classes.join(' ')
      }
    }
  }
</script>

<style lang="scss">

  .badge {
    /*@apply text-mf-white inline-block font-medium text-sm px-4 py-2 shadow uppercase rounded hover:shadow-md;*/

    @apply inline-block visible p-0 text-center no-underline;

    box-sizing: border-box;
    font: inherit;
    border: 0;
    border-radius: 0;
    background: 0 0;
    color: inherit;
    user-select: none;

    & > div:not(:empty) {
      @apply mr-1;
    }



    color: #fff;
    padding: 11px 32px;
    //@include FontWeight(Medium);
    border: 1px solid transparent;
    border-radius: 24px;


  }

  .badge-primary {
    background-color: white;
    padding: 10px 25px;
    & > div:not(:empty) {
      margin-right: 10px;
    }
    @apply text-color-dark-purple;

    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
    border-radius: 10px;

  }

  .badge-secondary {
    background: transparent;
    //border-color: $--color-white;
    border-color: white;

   /* &:focus,*/ &:hover {
      border-color: rgba(255, 255, 255, .6);
    }
  }

  .badge-primary-green {
    //background: $--color-green;
    background: #00B956;

    /*&:focus,*/ &:hover {
      //background: lighten($--color-green, 5%);
      background: lighten(#00B956, 5%);
    }
  }

  .badge-transparent {
    @apply text-color-black bg-transparent;
    border: 1px solid rgba(51, 51, 51, 0.15);
  }

  .badge-size-l {
    padding-top: 17px;
    padding-bottom: 17px;
    border-radius: 30px;
  }


</style>
